import { atom } from 'recoil';

export const unreadNotificationCountAtom = atom({
  key: 'unreadNotificationCountAtom',
  default: 0,
});
